import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-content'>
        <div className='footer-section footer-logo-section'>
          <Link to='/' onClick={() => window.scrollTo(0, 0)}>
            <img src="/images/logo-white.png" alt="logo" className='footer-logo-img' />
          </Link>
        </div>

        <div className='footer-section'>
          <h3>SHOP</h3>
          <Link to='/our-coffee' onClick={() => window.scrollTo(0, 0)}>Our Coffee</Link>
          <Link to='/coffee-roaster' onClick={() => window.scrollTo(0, 0)}>Coffee Roaster</Link>
        </div>

        <div className='footer-section'>
          <h3>BOOKING</h3>
          <Link to='/booking' onClick={() => window.scrollTo(0, 0)}>Private Class</Link>
          <Link to='/team-building' onClick={() => window.scrollTo(0, 0)}>Team Building</Link>
          <Link to='/booking' onClick={() => window.scrollTo(0, 0)}>Pop-Up Service</Link>
        </div>

        <div className='footer-section'>
          <h3>ABOUT</h3>
          <Link to='/our-story' onClick={() => window.scrollTo(0, 0)}>Our Story</Link>
          <Link to='/contact' onClick={() => window.scrollTo(0, 0)}>Contact</Link>
          <Link to='/career' onClick={() => window.scrollTo(0, 0)}>Career</Link>
        </div>
        
        <div className='footer-section footer-media-section'>
          <h3>SOCIAL MEDIA</h3>
          <a
            href='https://www.instagram.com/offf_the_roast_official/'
            target='_blank'
            rel='noopener noreferrer'
            className='media-link'
          >
            <i className='fab fa-instagram' /> Instagram
          </a>
          <a
            href='https://www.facebook.com/huang.jacob.125'
            target='_blank'
            rel='noopener noreferrer'
            className='media-link'
          >
            <i className='fab fa-facebook-f' /> Facebook
          </a>
          <a
            href='https://www.youtube.com/@offftheroast'
            target='_blank'
            rel='noopener noreferrer'
            className='media-link'
          >
            <i className='fab fa-youtube' /> YouTube
          </a>
        </div>

        <div className='footer-section'>
          <h3>CONTACT</h3>
          <p>Email: info@offftheroast.com</p>
        </div>
        
      </div>
      
      <div className='footer-bottom'>
        <div className='footer-legal-links'>
          <Link to='/terms-of-use' onClick={() => window.scrollTo(0, 0)}>Terms of Use</Link>
          <Link to='/privacy-policy' onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
          <Link to='/terms-of-service' onClick={() => window.scrollTo(0, 0)}>Terms of Service</Link>
        </div>
        <p className='copyright'>© 2026 OFFF THE ROAST. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;